import { render, staticRenderFns } from "./ReportsDashboardMetric.vue?vue&type=template&id=82bdd546&scoped=true&"
import script from "./ReportsDashboardMetric.vue?vue&type=script&lang=js&"
export * from "./ReportsDashboardMetric.vue?vue&type=script&lang=js&"
import style0 from "./ReportsDashboardMetric.vue?vue&type=style&index=0&id=82bdd546&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bdd546",
  null
  
)

export default component.exports